import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

// App Check proves a call comes from this website in a real browser. The
// review/reply/like/report functions refuse calls without it, which is what
// stops scripted spam without making guests solve a captcha. reCAPTCHA
// Enterprise here runs invisibly in the background.
//
// Must be initialised before anything calls a function. Skipped (with a
// warning) when no site key is configured, in which case posting fails
// against deployed functions but the rest of the site works.
const appCheckSiteKey = process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY;
if (typeof window !== 'undefined' && appCheckSiteKey) {
  if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
    // eslint-disable-next-line no-restricted-globals
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'test') {
  console.warn('App Check is not configured (REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY); posting will be refused.');
}

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Local development against the Firebase emulators (`firebase emulators:start`,
// ports from firebase.json) instead of the live project. Opt-in, and only ever
// on localhost, so a stray env var can't point production at nothing.
if (
  process.env.REACT_APP_USE_EMULATORS === 'true' &&
  typeof window !== 'undefined' &&
  window.location.hostname === 'localhost'
) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}

export default app;

export const BUSINESSES = 'businesses';
